import * as $ from "jquery";
import * as _ from "lodash";
import "select2";
import { DashboardChannelCollection } from "../../../../../collections/DashboardChannels";
import { ModuleCollection } from "../../../../../collections/Modules";
import { Utils } from "../../../../../common/utils";
import { DashboardChannel } from "../../../../../models/DashboardChannel";
import { BaseModifyDashboardWidgetView, BaseModifyDashboardWidgetViewOptions } from "../_BaseModifyWidgetView";
const Dropzone = require("dropzone");
const crypto = require("crypto");

declare var App: any;

interface GaugeTypes {
    name: string;
    customLabel: string;
    id: number;
}

export class ModifyLobbyViewWidget extends BaseModifyDashboardWidgetView {
    private widgetChannels: DashboardChannel[];
    private template = _.template(require("templates/modals/dashboard/modify_widgets/lobbyview/lobbyview.html"));
    private gaugeTemplate = _.template(require("templates/modals/dashboard/modify_widgets/lobbyview/gauge.html"));
    private selectedModules = [];
    private bgImg = "";
    private logoImg = "";
    private firstRender = true;
    private selectedGauges;
    private gaugeTypes: GaugeTypes[] = [];
    private enableCustomLabels: boolean = false;

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(
            <any>_.extend(
                {
                    tagName: "div",
                    className: "widget-type-lobby-view",
                    events: {
                        "change .install-select": "handleInstallSelectChange",
                        "change .module-select": "handleModuleSelectChange",
                        "change .customize-labels-checkbox": "handleCustomLabelsChange",
                        "click .add-gauge-btn": "handleAddGauge",
                        "click .gauge-delete": "handleDeleteGauge",
                        "change .gauges-layout select": "handleGaugeSelectChange",
                        "input .dashboard-name-input": "handleNameChange",
                        "change .tab select": "handleTabChange",
                    },
                },
                options
            )
        );

        this.widgetChannels = null;
        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: [],
            });
            this.widgetChannels = [];
        } else {
            this.widgetChannels = this.options.dashboardChannelCollection.where({
                dashboard_widget_id: this.options.widget.get("id"),
            });
        }
    }

    render() {
        var selectedInstallId = Number(this.options.widget.getParamValue("SELECTED_INSTALLATION", null));
        this.$el.html(
            this.template({
                dashboardCategoryCollection: this.options.dashboardCategoryCollection,
                dashboardTabCollection: this.options.dashboardTabCollection,
                widget: this.options.widget,
                img_url: require("../../../../../../img/widgettypes/lobbyviewsmall.png"),
                categoryId: this.options.widget.get("dashboard_category_id")
                    ? this.options.widget.get("dashboard_category_id")
                    : this.options.categoryId,
                tabId: this.options.tabId,
                organizationCollection: this.options.organizationCollection,
                installCollection: this.options.installCollection,
                lastSelectedInstallId: selectedInstallId,
                enableCustomLabels: this.enableCustomLabels,
            })
        );

        if (!this.options.widget.isNew()) {
            this.selectedGauges = JSON.parse(this.options.widget.getParamValue("GAUGE_CONFIG", "{}"));
            if (this.selectedGauges.secondaries.length !== 0) {
                for (const gauge of this.selectedGauges.secondaries) {
                    const customLabel = gauge.customLabel;
                    this.handleAddGauge();
                }
            }
        }

        this.$("select").select2(Utils.Select2.defaultOptions);

        // Customize Labels toggle
        (<any>this.$('.customize-labels input[type="checkbox"]')).bootstrapToggle();
        const rawEnableCustomLabels = this.options.widget.getParamValue('ENABLE_CUSTOM_LABELS', false);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.enableCustomLabels = !!Number(rawEnableCustomLabels);
        if (this.enableCustomLabels) (<any>this.$(".customize-labels input")).bootstrapToggle("on");

        this.$(".install-select").trigger("change");
        this.renderDropzones();

        return this;
    }

    show() {
        this.$('.tab select').select2(Utils.Select2.defaultOptions);
        this.initializeCategorySelect(".category select");
    }

    handleTabChange(e: JQuery.Event) {
        var $select = this.$('.tab select');
        var rawValue = $select.val();
        var tabId = rawValue === '' || rawValue === null || rawValue === undefined ? null : Number(rawValue);
        this.options.tabId = tabId;
        this.reloadCategoriesForTab(tabId);
    }

    checkCanSaveWidget() {
        var savable = false;
        var name = this.$(".dashboard-name-input").val();
        var installId = Number(this.$(".install-select").val());
        var primaryGauge = Number(this.$(".primary-gauge select").val());

        if (name && installId && this.selectedModules.length != 0 && primaryGauge > 0 && this.gaugeTypes.length > 1)
            savable = true;
        this.options.parentView.setSavable(savable);
        savable ? $(".save").removeAttr("disabled") : $(".save").attr("disabled", "true");
        return savable;
    }

    private handleNameChange() {
        this.checkCanSaveWidget();
    }

    private handleInstallSelectChange(e: JQuery.UIEventBase) {
        var installSelect = $(e.currentTarget);
        var installId = Number($(installSelect).val());

        if (!installId) return;

        // Save this as the last selected Id on the dashboard
        App.setLastSelectedInstallId(installId);

        //Get supported modules for Installation
        this.options.moduleCollections[installId] = new ModuleCollection([], { installId: installId });

        $.ajax({
            type: "GET",
            url: this.options.moduleCollections[installId].urlSupportedModules(),
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            success: (response) => {
                this.options.moduleCollections[installId] = new ModuleCollection([response], { installId: installId });

                var moduleSelect = this.$(".module-select");
                moduleSelect.empty();

                if (this.options.permissionCollection.canViewInstall(Number(installId))) {
                    var placeholder = " Select Modules";
                    var disabled = false;
                    if (response.length == 0) {
                        placeholder = "No supported modules";
                        disabled = true;
                    }
                    moduleSelect.empty().select2(
                        _.extend(
                            {
                                placeholder: placeholder,
                                disabled: disabled,
                                data: this.buildModuleOptions(response),
                            },
                            Utils.Select2.defaultOptions
                        )
                    );
                    moduleSelect.trigger("change");
                } else {
                    moduleSelect.select2(
                        _.extend(
                            {
                                disabled: !installId,
                            },
                            Utils.Select2.defaultOptions
                        )
                    );
                }

                moduleSelect.trigger("change");
            },
        });

        this.checkCanSaveWidget();
    }

    private buildModuleOptions(modules) {
        var options = [];
        this.selectedModules = this.options.widget.getParamValue("SELECTED_MODULES", []);

        _.forEach(modules, (module) => {
            var option = {
                id: module.module_id,
                text: `${module.module_number} - ${module.module_location}`,
                selected: "",
            };
            if (_.includes(this.selectedModules, module.module_id)) option.selected = "selected";

            options.push(option);
        });

        if (options.length) return options;
        return [{ id: "", text: "No Modules with Indoor Air Quality Sensors Found" }];
    }

    private handleModuleSelectChange(e: JQuery.UIEventBase) {
        var installId = Number(this.$(".install-select").val());
        var moduleSelect = $(e.currentTarget);
        const selectedModulesRaw = _.castArray($(moduleSelect).val());
        this.selectedModules = _.map(selectedModulesRaw, Number);

        //Get supported gauge types
        var channels = new DashboardChannelCollection([], {
            dashboardId: this.options.dashboardId,
            modulesIds: this.selectedModules,
        });
        if (this.selectedModules.length == 0) {
            const opts: Select2.Options = _.cloneDeep(Utils.Select2.defaultOptions);
            opts.disabled = true;
            opts.data = null;

            _.each(this.$(".gauges-layout select"), (select) => {
                $(select).empty().select2(opts);
                $(".gauge-types-qty").html("");
            });
        } else {
            $.ajax({
                type: "POST",
                url: channels.urlSupportedGaugeTypes(),
                data: JSON.stringify({ models: this.selectedModules }),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                success: (response) => {
                    var options: Select2.DataFormat[] = this.buildGaugeOptions(response);
                    $(".gauge-types-qty").html(
                        `There are ${response.length} available sensor types across the modules you selected.`
                    );
                    _.each(this.$(".gauges-layout select"), (select, idx) => {
                        var selected = $(select).val();
                        if (!this.options.widget.isNew() && this.firstRender) {
                            if (idx == 0) {
                                selected = this.selectedGauges.primary.type_id;
                                const customLabel = this.selectedGauges.primary.custom_label;
                                $(select).siblings(".gauge-custom-label-input").val(customLabel);
                            } else {
                                selected = this.selectedGauges.secondaries[idx - 1].type_id;
                                const customLabel = this.selectedGauges.secondaries[idx - 1].custom_label;
                                $(select).siblings(".gauge-custom-label-input").val(customLabel);
                            }
                        }

                        $(select).empty();
                        if (_.find(options, { id: Number(selected) })) {
                            options.forEach((option) => {
                                option.id == selected ? (option.selected = true) : (option.selected = false);
                            });
                        }

                        const s2Opts: Select2.Options = _.cloneDeep(Utils.Select2.defaultOptions);
                        s2Opts.disabled = false;
                        s2Opts.placeholder = {
                            id: "-1",
                            text: "Select a gauge type",
                        };
                        s2Opts.data = options;
                        $(select).empty().select2(s2Opts);

                        $(select).trigger("change");
                    });
                    this.firstRender = false;
                },
            });
        }

        this.checkCanSaveWidget();
    }

    private handleCustomLabelsChange(e: JQuery.UIEventBase) {
        this.enableCustomLabels = $(e.currentTarget).is(":checked");
        this.$(".gauge-custom-label-input").toggleClass("hidden", !this.enableCustomLabels);
    }

    private buildGaugeOptions(gaugeTypes): Select2.DataFormat[] {
        var options: Select2.DataFormat[] = [{ id: -1, text: "", selected: false }];
        _.each(gaugeTypes, (gauge) => {
            var option = {
                id: gauge.gauge_type_id,
                text: `${gauge.gauge_type_name} (${gauge.gauge_type_units})`,
                selected: false,
            };
            options.push(option);
        });

        return options;
    }

    private handleGaugeSelectChange() {
        this.gaugeTypes = [];
        _.each(this.$(".gauges-layout select"), (select) => {
            const $select = $(select); // Cache the jQuery object
            const value = Number($select.val());
            const customLabel = $select.siblings(".gauge-custom-label-input").val() || "";

            let name = "";
            if (value > 0) name = $select.select2("data")[0].text;
            const repeated = this.gaugeTypes.some((gaugeType) => gaugeType["id"] === value);
            if (value > 0 && !repeated) {
                this.gaugeTypes.push({
                    name: name,
                    customLabel: this.enableCustomLabels ? String(customLabel) : "",
                    id: value,
                });
            }
        });

        this.checkCanSaveWidget();
    }

    private handleAddGauge() {
        //max 6 gauges
        $(".secondary-gauges .secondary-gauge").length >= 5 ? $(".add-gauge-btn").hide() : $(".add-gauge-btn").show();
        this.$(".secondary-gauges .add-gauge").before(
            this.gaugeTemplate({
                enableCustomLabels: this.enableCustomLabels,
            })
        );

        if (!this.firstRender) this.$(".module-select").trigger("change");
    }

    private handleDeleteGauge(e) {
        var iconClicked = $(e.currentTarget);
        var indexClicked = _.findIndex(_.map(this.$(".gauge-delete"), (e) => e === iconClicked.get(0)));

        // Remove the gauge select
        this.$(`.secondary-gauges .secondary-gauge:nth-child(${indexClicked + 1})`).remove();
        $(".secondary-gauges .secondary-gauge").length >= 6 ? $(".add-gauge-btn").hide() : $(".add-gauge-btn").show();
        this.checkCanSaveWidget();
    }

    preSave() {
        //save widget parameters
        this.options.widget.setParamValue("MAIN_TITLE", this.$(".main-title-input").val());
        this.options.widget.setParamValue("DASHBOARD_NAME", this.$(".dashboard-name-input").val());

        this.options.widget.setParamValue("COMPANY_LOGO", this.logoImg);
        this.options.widget.setParamValue("BACKGROUND_IMAGE", this.bgImg);

        this.options.widget.setParamValue("SELECTED_MODULES", JSON.stringify(this.selectedModules));

        var installId = Number(this.$(".install-select").val());
        this.options.widget.setParamValue("SELECTED_INSTALLATION", installId);

        var timezone = this.options.installCollection.findWhere({ id: installId }).get("timezone");
        this.options.widget.setParamValue("TIMEZONE", timezone);

        this.options.widget.setParamValue(
            "ENABLE_CUSTOM_LABELS",
            this.$(".customize-labels input").is(":checked") ? true : false
        );

        this.handleGaugeSelectChange();
        this.options.widget.set({
            gaugeTypes: this.gaugeTypes,
            moduleIds: this.selectedModules,
        });

        return this.checkCanSaveWidget();
    }

    postSave() {
        if (!this.options.widget.get("public_id")) {
            const generatePubKey = (widgetId) => {
                const id = crypto.randomBytes(16).toString("hex");
                return id + widgetId;
            };
            //set public_id
            this.options.widget.set({
                public_id: generatePubKey(this.options.widget.get("id")),
            });

            // the API for postSave is synchronous, but this implementation requires handling of an async XHR operation -- problem!
            this.options.widget.save(); // TODO: fix to not drop the outcome of the XHR
            return true;
        }
        return false;
    }

    renderDropzones() {
        var me = this;
        _.each(this.$(".dropzone"), (element) => {
            var isForBg = $(element).attr("id") == "bgImgDropzone";
            var myDropzone = new Dropzone(element, {
                url: "/",
                maxFilesize: 5,
                uploadMultiple: false,
                acceptedFiles: "image/*",
                maxFiles: 1,
                addRemoveLinks: true,
                dictDefaultMessage: "Upload your image file here",
                autoProcessQueue: false,
                init: function () {
                    var image = isForBg
                        ? me.options.widget.getParamValue("BACKGROUND_IMAGE", "")
                        : me.options.widget.getParamValue("COMPANY_LOGO", "");
                    if (image) {
                        this.addCustomFile = function (file, thumbnail_url, response) {
                            this.files.push(file);
                            this.emit("addedfile", file);
                            this.emit("thumbnail", file, thumbnail_url);
                            this.emit("processing", file);
                            this.emit("success", file, response, false);
                            this.emit("complete", file);
                        };

                        this.addCustomFile(
                            {
                                processing: true,
                                accepted: true,
                                name: "",
                                size: "",
                                status: Dropzone.SUCCESS,
                            },
                            image,
                            {
                                status: "success",
                            }
                        );
                        isForBg ? (me.bgImg = image) : (me.logoImg = image);
                    }
                    this.on("addedfile", function (file) {
                        if (this.files.length > 1) {
                            this.removeFile(this.files[0]);
                        }
                    });
                },
                removedfile: function (file) {
                    var _ref;
                    isForBg ? (me.bgImg = "") : (me.logoImg = "");
                    return (_ref = file.previewElement) != null
                        ? _ref.parentNode.removeChild(file.previewElement)
                        : void 0;
                },
                error: function (file, message) {
                    if (isForBg) {
                        $("#emptyFilesMessageBg").html(message);
                        $("#emptyFilesMessageBg").fadeIn("fast").delay(3000).fadeOut("slow");
                    } else {
                        $("#emptyFilesMessageLogo").html(message);
                        $("#emptyFilesMessageLogo").fadeIn("fast").delay(3000).fadeOut("slow");
                    }
                    this.removeFile(file);
                },
                success: function () {},
                canceled: function () {
                    //cancelled files handler
                },
                addedfiles: function (files) {
                    // added files handler
                    if (this.files[1] != null) {
                        this.removeFile(this.files[0]);
                    }
                    var file = files[0];
                    if (file) {
                        var reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function () {
                            isForBg ? (me.bgImg = String(reader.result)) : (me.logoImg = String(reader.result));
                            me.checkCanSaveWidget();
                        };
                        reader.onerror = function (error) {
                            (<any>$).notify("The file could not be loaded", "error");
                            throw error;
                        };
                    }
                },
            });
        });
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/modify_widgets/lobbyview/ModifyLobbyViewWidget.ts